export enum MemberOrderType {
    Wholesale = 'Wholesale',
    Retail = 'Retail'
}
